import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Directive()
export abstract class RxntSubscribeControl implements OnDestroy {
  destroy$: Subject<void>;
  programmaticUpdate: boolean = false;

  constructor() {
    this.destroy$ = new Subject<void>();
  }

  suppressEvents(callback: () => void): void {
    if (this.programmaticUpdate) {
      return;
    }

    this.programmaticUpdate = true;
    try {
      callback();
    } finally {
      this.programmaticUpdate = false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
